import { addToQuoteValidated, removeMember, setQuoteDetailsValue, updatePremiumPaidupOndobEdit } from '../../../actions/sizotsaFuneralCover/quote';
import { SF_COVER_CATEGORIES } from '../../../actions/sizotsaFuneralCover/types';
import { FIELD_STATUS, FORM_STATUS } from '../../../reducers/status';
import { getBenefitsDetails, getCoverType, getEditQuoteDetails, getQuoteForm } from '../../../selectors/sizotsaFuneralCover/quote';
import { getActivePageIndex } from '../../../selectors/sizotsaFuneralCover/routing';
const validationFields = {
    [SF_COVER_CATEGORIES.MYSELF]: ['dateOfBirth','hearAboutUs','hearAboutUsPlatform','socialPlatform','gender','needIncomeStabilization'],
    [SF_COVER_CATEGORIES.ME_AND_MY_DIRECT_FAMILY]: ['dateOfBirth','hearAboutUs','hearAboutUsPlatform','socialPlatform','gender','needIncomeStabilization'],
    [SF_COVER_CATEGORIES.LIVES_COVERED_SIDE_DRAWER]: ['relationship', 'selectedCoverCategory', 'dateOfBirth'],
    [SF_COVER_CATEGORIES.BENIFITS]:['benefitsDetails'],
    [SF_COVER_CATEGORIES.BENEFECIARY]:['memberFromLivesCovered','beneficiaryName','relationship','title','nationality','firstName','surname','dateOfBirth','email','cellphone','id'],
    [SF_COVER_CATEGORIES.LIVES_COVERED_DETAILS_SIDEDRAWER]:['title','nationality','firstName','surname','childHaveSpecialNeed','childIsStudent','dateOfBirth','id'],
    [SF_COVER_CATEGORIES.ADD_COVER_IN_LIVESCOVERED]:['relationship', 'selectedCoverCategory','title','nationality','firstName','surname','childHaveSpecialNeed','childIsStudent','dateOfBirth','id'],
    [SF_COVER_CATEGORIES.AGENT]:['agentDetail','agentCode', 'currentResidence'],
    // [SF_COVER_CATEGORIES.BENIFITS]:[],
    default:['dateOfBirth'],
};
export const quotingRules = (store, next, action) => {
    const result = next(action);
    const state = store.getState();
    const coverType = getCoverType(state);
    const formFields = getQuoteForm(state);
    const {incomeStabilization} = getBenefitsDetails(state);
    const activePageIndex = getActivePageIndex(state);

    const { id, category } = getEditQuoteDetails(state);
    // const inValidFields = validationFields[coverType].filter(
    //     (field) => formFields[field].status !== FIELD_STATUS.VALID
    // );

    const inValidFields = (validationFields[coverType??'default']||[])?.flatMap((field) => {
        const dependentField = formFields[formFields[field]?.dependentField];
        const dependentValue = formFields[field];
        const defaultValidationCondition=(dependentValue,actualValue)=> dependentValue?.dependentValue === actualValue.value
const validationCondition=formFields[field].validationCondition ?? defaultValidationCondition
        const validate=()=>formFields[field].status !== FIELD_STATUS.VALID ? field : []
        if (dependentField) {
           return validationCondition(dependentValue,dependentField) ? validate() : []
        } else {
            return validate()
        }
    });
    (inValidFields?.length === 0 && activePageIndex===2) && store.dispatch(setQuoteDetailsValue({ fieldType:'formStatus', value:FORM_STATUS.VALID, displayValue:null }));
    inValidFields.length === 0 && id && store.dispatch(removeMember({ id, category })); 
    (inValidFields?.length === 0 && incomeStabilization?.value && action.value.relation==="Myself" && formFields.coverAmount.value<20000 && store.dispatch(updatePremiumPaidupOndobEdit()))
    inValidFields.length
        ? validateQuoteDetails(store, inValidFields, formFields)
        : store.dispatch(addToQuoteValidated(action.value));

    return result;
};

const validateQuoteDetails = (store, inValidFields, formFields) => {
    inValidFields?.map((fieldType) =>
        store.dispatch(setQuoteDetailsValue({ fieldType, value: formFields[fieldType].value, displayValue: null }))
    );
};
